export default __webpack_public_path__ + "static/media/Straining Strings.d814d383.png";